module.exports = __webpack_public_path__ + "static/img/banner.ef81632.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qiwei/banner.png
// module id = z7bx
// module chunks = 94